import { FlexRow } from '@gorila-shared-ui/components';
import { useStyles } from '../../hooks/useStyles';
import { UserMenu } from '../dashboard/UserMenu';
import NavbarWrapper from '../ui/NavbarWrapper';

function FleetNavbar() {
  const { theme } = useStyles();

  return (
    <NavbarWrapper>
      <FlexRow gap={theme.sizing.scale0}>
        <UserMenu isFleet />
      </FlexRow>
    </NavbarWrapper>
  );
}

export default FleetNavbar;
